<template>
  <div id="searchshow">
    <img class="sbg" src="../../static/imges/searchbg.png" alt="">
    <div class="secont">
      <div class="top_lnr">
        <div class="left_lsn">
          <div class="logosearch">
            <div id="logo">
              <img @click="this.$router.push('/')" src="../../assets/7w.png" alt="exp2c.com">
            </div>
            <div class="cut">
              <div class="title">
                <span
                v-for="(item,index) in btnlist" :key="index"
                :class="{active:activeClass === index}"
                @click="btnclass(index)">{{item}}</span>
              </div>
              <div id="sear">
                <!-- <input id="searin" type="text" :value="inputValue"/> -->
                <el-input id="searin" v-model="inputValue"></el-input>
                <button class="sou" @click="sou">{{$t('m.search.search')}}</button>
              </div>
            </div>
          </div>
          <div id="nav">
            <Nav/>
          </div>
        </div>
        <div id="reg-log">
          <RegLog/>
        </div>
      </div>
      <div id="toutiao" class="bottom_tout">
        <div class="toutiao_cont">
          <span id="title">{{toudata.tou}}</span>
          <vue-seamless-scroll
          :data="toudata.cont"
          :class-option="optionHover"
          class="seamless-warp">
            <div id="cont">
              <p v-for="(item,index) in toudata.cont" :key="index" @click="totoutiao(item)">{{item.title}}</p>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Nav from './Nav'
import RegLog from '../../components/RegLog'
import { reactive, ref } from 'vue'
import http from '../../api/http'

// 查询今日头条接口
const getTodayHeadline = (data) => {
  return http.get('/mall-portal/mall/post/queryPopularPosts', data)
}
export default {
  name: 'Search',
  components: {
    Nav, RegLog
  },
  data () {
    return {
      btnlist: [
        this.$t('m.search.product'), this.$t('m.search.supplier')
      ],
      inputValue: '',
      activeClass: ref(0),
      toudata: reactive({
        tou: `${this.$t('m.search.Today_Headlines')}：`,
        cont: []
      })
    }
  },
  computed: {
    optionHover () {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 0, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: false, // 开启数据实时监控刷新dom
        singleHeight: 40, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 2000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  mounted () {
    this.initdata()
  },
  methods: {
    btnclass (k) {
      this.activeClass = k
      // console.log(k)
    },
    async initdata () { // 初始化首页数据
      const Headline = await getTodayHeadline({
        pageNum: 1,
        pageSize: 3,
        postOrInformation: 2
      })
      // console.log(Headline)
      if (Headline.data.code === 200) {
        this.toudata.cont = Headline.data.data.list
      }
    },
    sou () {
      console.log(this.inputValue)
      this.$router.push({
        path: '/search',
        query: { sedata: this.activeClass, data: this.inputValue }
      })
    },
    totoutiao (item) {
      console.log(item)
      this.$router.push({
        path: '/coffee/informationArticle',
        query: {
          id: item.id
        }
      })
    }
  },
  setup () {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
#searchshow{
  position: relative;
  // padding: 0 360px;
  // background: url('../../static/imges/searchbg.jpg') no-repeat;
  // width: 100%;
  // background: url('../../static/imges/searbg.png') no-repeat;
  margin: 0 auto;
  overflow: hidden;
  // box-sizing: border-box;
  // 背景图
  .sbg{
    position: absolute;
    // width: 1200px;
    width: 100%;
    height: 360px;
    background: linear-gradient(89deg, rgba(131,99,79,0.06) 0%, #422514 18%, #402311 72%, rgba(111,80,61,0) 89%);
    border-radius: 0px 0px 0px 0px;
    opacity: 0.9;
    // display: block;
    // height: 290px;
    z-index: 1;
    margin: 0 auto;
  }
  .secont{
    display: flex;
    flex-flow: column;
    // z-index: 22;
    .top_lnr{
      z-index: 22;
      // height: 297px;
      background: #3b1c0141;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      .left_lsn{
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        padding: 10px 0;
        .logosearch{
          display: flex;
          // position: absolute;
          // top: 30px;
          z-index: 99;
          align-items: center;
          #logo{
            img{
              // margin-right: 20px;
              cursor: pointer;
              width: 145px;
            }
          }
          .cut{
            padding:0 30px;
            padding-right: 50px;
            .title{
              display: block;
              span{
                background: #3C1C0B;
                border-radius: 0px 10px 10px 0px;
                font-weight: bold;
                color: #FFFFFF;
                display: block;
                float: left;
                font-size: 16px;
                min-width: 60px;
                padding: 0 5px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
                cursor: pointer;
              }
              .active{
                border: 1px solid #F3ECDC;
                background: #F3ECDC;
                color: #3B1C01;
              }
            }
            #sear{
              // padding: 10px 10px;
              width: 659px;
              flex: 1;
              display: flex;
              align-items: center;
              /deep/ #searin{
                border: 1px solid #FFFFFF !important;
                border-radius: 0 0 0 10px !important;
                box-sizing: border-box;
                color: #FFFFFF;
                background: 0 !important;
                flex: 1;
                height: 40px;
                font-size: 16px;
                padding: 0 15px;
                outline: none;
                border-radius: 0;
              }
              .sou{
                // font-size: 14px;
                font-family: Source Han Sans SC;
                border-radius: 0px 10px 10px 0px;
                background: #F3ECDC;
                color: #3C1C0B;
                font-weight: bold;
                width: 120px;
                height: 40px;
              }
            }
          }
          #nav{
            z-index: 20;
          }
        }
      }
      #reg-log{// 搜索 logo
        // position: absolute;
        display: block;
        // top: 0;
        // right: 360px;
        // margin: 20px 0;
        width: 300px;
        height: 257px;
        padding: 30px;
        box-sizing: border-box;
        // background: linear-gradient(180deg, #FFFEFB 0%, #F4F4F4 100%);
        box-shadow: 0px 5px 11px 0px rgba(0,0,0,0.06);
        border-radius: 5px;
        // opacity:  0.8;
        background: rgba($color: #FFFEFB, $alpha: 0.6);
      }
    }
    #toutiao{
      // position: absolute;
      // left: 0;
      // bottom: 0;
      z-index: 22;
      background: #FFFFFF;
      width: 100% !important;
      height: 40px;
      .toutiao_cont{
        margin: 0 auto;
        width: 1200px;
        height: 40px;
        display: flex;
        align-items: center;
        cursor: pointer;
        #title{
          // color: #3B1C01;
          color: #3C1C0B;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
        }
        .seamless-warp{
          // flex: 1;
          max-width: 1100px;
          height: 40px;
          overflow: hidden;
          #cont{
            text-overflow:ellipsis;
            white-space:nowrap;
            overflow:hidden;
            p{
              width: 100%;
              height: 40px;
              line-height: 40px;
              font-weight: bold;
              color: #474747;
            }
          }
        }
      }
    }
  }
}
</style>
